import script from "./settings-general.linux.vue?vue&type=script&setup=true&lang=ts"
export * from "./settings-general.linux.vue?vue&type=script&setup=true&lang=ts"

import "./settings-general.linux.vue?vue&type=style&index=0&id=013cdcda&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013cdcda"]])

export default __exports__